import { React, PT, connect, WithData } from '@gasbuddy/react';
import BN from 'bignumber.js';
import _ from 'lodash';
import { Dimmer, Loader, Statistic, Divider, Container, Button, Form, Icon } from 'semantic-ui-react';
import { Action } from '../../reducers/actions';
import { Transactions } from './Transactions';

const STATPAD = 80;

const Header = ({ data, loading }) => (
  <Dimmer.Dimmable dimmed={loading}>
    <Dimmer active={loading}>
      <Loader />
    </Dimmer>
    <div style={{ textAlign: 'center' }}>
      <Statistic
        value={data ? data.count : 0}
        label="Transactions"
        style={{ paddingRight: STATPAD }}
      />
      <Statistic
        value={data ? data.accounts : 0}
        label="Accounts"
        style={{ paddingRight: STATPAD, paddingLeft: STATPAD }}
      />
      <Statistic
        value={data ? `$${new BN(data.total || 0).toFormat(2)}` : ''}
        label="Total Value"
        style={{ paddingLeft: STATPAD }}
      />
      <Divider />
    </div>
  </Dimmer.Dimmable>
);

Header.propTypes = {
  data: PT.shape({
    count: PT.string,
    total: PT.string,
  }),
  loading: PT.bool,
};

Header.defaultProps = {
  data: null,
  loading: false,
};

export const Unbalanced = connect(({ unbalanced }) => ({ unbalanced }))(
  ({ dispatch, unbalanced }) => (
    <Transactions
      url="/payments/transactions/unbalanced"
      showAccount
      showReason
      onData={(state, txlist) => dispatch({
        type: Action.Payment.Unbalanced.Cache,
        payload: {
          state,
          txlist,
        },
      })}
      valuesForState={(state) => {
        if (_.isEqual(state, unbalanced.state)) {
          return { data: unbalanced.txlist };
        }
        return null;
      }}
      header={(
        <WithData url="/payments/transactions/unbalanced-summary">
          <Header />
        </WithData>
      )}
      footer={(
        <Container fluid>
          <Form style={{ marginBottom: 50 }} method="POST" action="/payments/transactions/unbalanced-export">
            <Button
              type="submit"
              secondary
            >
              <Icon name="download" />
              {' '}
              Export All to CSV
            </Button>
          </Form>
        </Container>
      )}
    />
  ),
);
